import { render, staticRenderFns } from "./tooltip-overflow-keep-newlines.vue?vue&type=template&id=617945aa&"
import script from "./tooltip-overflow-keep-newlines.vue?vue&type=script&lang=js&"
export * from "./tooltip-overflow-keep-newlines.vue?vue&type=script&lang=js&"
import style0 from "./tooltip-overflow-keep-newlines.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('617945aa')) {
      api.createRecord('617945aa', component.options)
    } else {
      api.reload('617945aa', component.options)
    }
    module.hot.accept("./tooltip-overflow-keep-newlines.vue?vue&type=template&id=617945aa&", function () {
      api.rerender('617945aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shared/tooltip-overflow-keep-newlines.vue"
export default component.exports